<template>
    <div class="toolbox-content">
        <v-expansion-panels accordion class="sr-accordion" :value="value.objects.length === 1 ? 0 : null">
            <v-expansion-panel v-for="link in value.objects" :key="link.id">
                <v-expansion-panel-header>
                    <label>
                        <i></i>
                        <span>
                            <simple-svg
                                    :filepath=" getLayer(link.layer).iconUrl"
                                    :fill=" getLayer(link.layer).color"
                                    :stroke=" getLayer(link.layer).stroke"
                            ></simple-svg>
                            <div class="layer-title">{{ getLayer(link.layer).title }}</div>
                        </span>
                    </label>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <dynamic-layer :value="link" read-only no-class></dynamic-layer>
                    <v-btn
                            v-if="canEdit(link)"
                            @click="openStack(link)"
                            class="sr-button"
                            text
                            :loading="loading"
                            :disabled="loading"
                    >
                        Objekt bearbeiten
                    </v-btn>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
  import DynamicLayer from '@/components/toolbox/geoobject/layers/dynamic'
  import GeoObject from '@/models/GeoObject'
  import GeoObjectAPI from '@/api/geoObject'

  export default {
    props: {
      value: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    components: { DynamicLayer },
    methods: {
      openStack (item) {
        this.$toolbox.openStack({
          item: new GeoObject(item),
          onConfirm: async (toolbox) => {
            // hier die daten zum server senden
            // toolbox.contentData gibt das item zurück (GeoObjectCollection)
            let result = await GeoObjectAPI.udpate(toolbox.contentData.id, toolbox.contentData)

            toolbox.contentData.update(result.data)

            return result
          },
          onConfirmError: (toolbox, error) => {
            // hier den fehler in die toolbox setzen
            toolbox.errorData = error.response.data.error
          }
        }).then((result) => {
          if (typeof result.content === 'object' && result.content) {
            if (typeof result.content.isDeleted !== 'undefined' && result.content.isDeleted) {
              this.$delete(this.value.objects, this.value.objects.indexOf(item))
            }
          }
          if (result.confirmed) {
            // in einer association ist es immer readonly
            // result.content.readonly = true
            this.$set(this.value.objects, this.value.objects.indexOf(item), result.content)
            this.$alert.success('Erfolgreich gespeichert')
          }
        })
      },
      canEdit (object) {
        return !object.readonly
      }
    },
    computed: {
      getLayer () {
        return (layerId) => this.$store.getters['layer/get'](layerId)
      }
    }
  }
</script>

<style scoped>

</style>
